import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { voteInPoll, voteInPollFail, voteInPollSuccess } from './actionCreators';
import { select, call, all, put, takeLatest } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import ddt from '@wix/da-ddt';
import { putEntities } from '../../redux/entities/actions';
import { normalize } from 'normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { ReferralType } from '@wix/da-bi/pkg/constants';
const logger = ddt.createLogger('polls');
function fakeResponse({ data: { pollid, answerid } }) {
    logger.log('faking the response!');
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const chance = require('chance').Chance(); // eslint-disable-line global-require
        const poll = deviationsByType.polls.find((p)=>p.deviationId === pollid) || chance.pickone(deviationsByType.polls);
        const answers = [
            ...poll.poll.answers
        ];
        if (!answers.some((a)=>a.answerId === answerid)) {
            answers[0] = _object_spread_props(_object_spread({}, answers[0]), {
                answerId: answerid
            });
        }
        return {
            success: true,
            poll: _object_spread_props(_object_spread({}, poll), {
                deviationId: pollid,
                poll: _object_spread_props(_object_spread({}, poll.poll), {
                    pollId: pollid,
                    hasVoted: true,
                    votedAnswerid: answerid,
                    answers
                })
            })
        };
    }
}
function* handlePollVote(action) {
    if (!action.payload) {
        logger.error('Tried to vote in an invalid poll', action);
        return;
    }
    const { pollId: pollid, answerId: answerid, userId: userid } = action.payload;
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.POLL_VOTE
        }));
        return;
    }
    const data = {
        pollid,
        answerid,
        userid
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: '/poll/vote',
        data
    }, fakeResponse);
    if (!result || !result.success || !result.poll) {
        yield put(voteInPollFail(action.payload));
        return;
    }
    const { entities } = normalize(result.poll, deviationSchema);
    yield all([
        put(voteInPollSuccess(_object_spread_props(_object_spread({}, action.payload), {
            poll: result.poll
        }))),
        put(putEntities({
            entities
        }))
    ]);
}
export default function* saga() {
    yield all([
        takeLatest(voteInPoll, handlePollVote)
    ]);
}

//# sourceMappingURL=saga.js.map